<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 품번 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 품명 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000957')"
						paramKey="partNm"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.partNm"
					>
					</search-input>
				</el-col>
				<!-- 검사번호 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000005')"
						paramKey="ckuNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.ckuNo"
					>
					</search-input>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cofNm"
						@commInput="setSearchParam"
						@keyup.native.delete="onCofNmInPutKeyDown()"
						:clearable="false"
						:propData="searchParams.cofNm"
						:readonly="!(flgOsGrp || flgPqyapGrp || flgPqyrvGrp || flgPqyrgGrp)"
					>
						<template v-slot:icon v-if="isButton_(scrId, 'CR') && (flgOsGrp || flgPqyapGrp || flgPqyrvGrp || flgPqyrgGrp)">
							<i class="icon-sf-search search-icon" @click="onCofPopup"></i
						></template>
					</search-input>
				</el-col>
				<el-col :span="4">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000999') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- 품명 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC002076')"
						paramKey="lotNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.lotNo"
					>
					</search-input>
				</el-col>
				<!--최종보기-->
				<el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">&nbsp;</span>
						<div>
							<el-checkbox @input="value => onCheck('lastYn', value)">{{ getMessage_('QWCC001886') }}</el-checkbox>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<!-- 검사상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001219')"
						paramKey="pgsStCd"
						@commChange="setSearchParam"
						:options="getPgsStPcList_"
						:propData="searchParams.pgsStCd"
					></select-combo>
				</el-col>

				<el-col :span="3">
					<search-input
							:label="getMessage_('QWCC002081')"
							paramKey="orderNo"
							@commInput="setSearchParam"
							:clearable="true"
							:propData="searchParams.orderNo"
						>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button
					line
					icon="search"
					:onClick="searchList"
					v-if="(isButton_(scrId, 'CR') && (flgPqyrgGrp || flgPqyrvGrp || flgPqyapGrp)) || flgOsGrp"
				>
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>

		<!-- 팝업 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuMng/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false }
	},
	data() {
		return {
			searchDateRange: []
		};
	},
	components: { SelectCombo, SearchInput, PartMngPopup, CompPopup },
	async created() {
		// this.getPartner();
		try {
			this.searchDateRange = [...this.getSearchMonths_];
			// await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}

			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getPartCkuMngList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		onCofPopup() {
			// this.$refs.partMngPopup.open(this.searchParams.cofCd);
			let params = {
				cpnyScn: '10',
				cpnyCd: this.searchParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		sendData({ partNo }) {
			this.setSearchParam_({ key: 'partNo', value: partNo });
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'cofCd', value: cpnyCd });
			this.setSearchParam_({ key: 'cofNm', value: cpnyNm });
		},
		getPartner() {
			let ppp = this.getPartnerInfo_();
		},
		onCheck(key, value) {
			// console.log(value);
			if (value) {
				this.setSearchParam_({ key, value: 'Y' });
			} else {
				this.setSearchParam_({ key, value: 'N' });
			}
		},
		onCofNmInPutKeyDown() {
			//지웠을때 실행함
			this.setSearchParam_({ key: 'cofCd', value: '' });
			this.setSearchParam_({ key: 'cofNm', value: '' });
		}
	},
	computed: { ...rootComputed, ...serviceComputed, ...qmsComputed }
};
</script>

<style></style>
